
export const SettingsModal = () => `
        <div id="settings-modal" class="settings-modal hidden">
            <div class="settings-content glass-panel">
                <div class="settings-header">
                    <h3><span class="icon">⚙️</span> AYARLAR</h3>
                    <button id="close-settings-btn" class="close-btn" title="Kapat">✖</button>
                </div>

                <div class="setting-group">
                    <label class="group-label">KONTROLLER</label>
                    <div class="setting-item" style="gap: 15px;">
                        <label><span class="icon">🔊</span> SES EFEKTLERİ</label>
                        <div style="display: flex; align-items: center; gap: 10px; flex: 1; justify-content: flex-end;">
                            <input type="range" id="sfx-volume-slider" class="volume-slider" min="0" max="1" step="0.1" value="0.6" aria-label="Ses Efekti Seviyesi">
                            <label class="switch" aria-label="Ses Efektlerini Aç veya Kapat">
                                <input type="checkbox" id="sfx-toggle-check" checked role="switch" aria-checked="true">
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="setting-group">
                    <label class="group-label">YAZI RENGİ</label>
                    <div class="color-selector" id="text-color-selector">
                        <button class="color-btn active" data-color="#ffffff" style="background: #ffffff;" title="Beyaz"></button>
                        <button class="color-btn" data-color="#ffd700" style="background: #ffd700;" title="Sarı"></button>
                        <button class="color-btn" data-color="#ff5252" style="background: #ff5252;" title="Kırmızı"></button>
                        <button class="color-btn" data-color="#3498db" style="background: #3498db;" title="Mavi"></button>
                        <button class="color-btn" data-color="#2ecc71" style="background: #2ecc71;" title="Yeşil"></button>
                    </div>
                </div>


                <div class="setting-group">
                    <label class="group-label">GÖRÜNÜM</label>
                    <div class="bg-selector-grid" id="bg-selector-grid">
                        <!-- Dynamic Grid of BG options -->
                    </div>
                    <small class="hint-text">Arka planı değiştirmek için bir tema seçin.</small>
                </div>

                <div class="settings-footer">
                    <span id="version-text">GADDAR v9.0 | 2026</span>
                </div>
            </div>
        </div>
`;
